import { render, staticRenderFns } from "./ModalPromotions.vue?vue&type=template&id=626f73cc&scoped=true"
import script from "./ModalPromotions.vue?vue&type=script&lang=js"
export * from "./ModalPromotions.vue?vue&type=script&lang=js"
import style0 from "./ModalPromotions.vue?vue&type=style&index=0&id=626f73cc&prod&lang=scss&scoped=true"
import style1 from "./ModalPromotions.vue?vue&type=style&index=1&id=626f73cc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626f73cc",
  null
  
)

export default component.exports